import { render } from "./Collegio.vue?vue&type=template&id=3c8ca89a"
import script from "./Collegio.vue?vue&type=script&lang=js"
export * from "./Collegio.vue?vue&type=script&lang=js"

import "./Collegio.vue?vue&type=style&index=0&id=3c8ca89a&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__